import { UserTypes } from "../../../shared/constants";
import { DebitMandateConfigurations } from "../../back-office/mandate-configurations/mandate-configurations";

export function FrontOfficeMandateConfigurations() {
  return <DebitMandateConfigurations userType={UserTypes.Frontoffice} />;
}
